export default __webpack_public_path__ + "static/media/iconLinkedin.27a3f479.svg";